import SetSecurityQuestions from './set-security-questions';

export default SetSecurityQuestions;
